"use strict";
import ObjectWithIDStore from "./object_with_id_store";
const store = new ObjectWithIDStore("TMSCustomerLoad");
export default store;
